// EL VÍNCULO EN LÍNEA, en JS puro · contrato 2.11.0 §2.10
// (DISEÑO-ACTIVACION-EN-LINEA §6). Lo que la pantalla y el escáner
// comparten y se prueba sin montar nada.

/** ¿El error de `start()` es un permiso de cámara negado? html5-qrcode lo
 *  entrega como texto («NotAllowedError: Permission denied») o como DOMException. */
export function esPermisoNegado(err) {
  const t = `${err?.name || ''} ${err?.message || ''} ${typeof err === 'string' ? err : ''}`;
  return /NotAllowed|Permission|denied|SecurityError/i.test(t);
}

/** Cómo dar el permiso de cámara, según el navegador. */
export function comoDarPermiso(ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '')) {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'En el iPhone: Ajustes → Safari → Cámara → Preguntar, y vuelve a esta página.';
  if (/SamsungBrowser/i.test(ua)) return 'En Samsung Internet: toca el candado junto a la dirección → Permisos → Cámara → Permitir.';
  return 'En Chrome: toca el candado junto a la dirección → Permisos → Cámara → Permitir.';
}

/** `EET5D` → `EET-5D` mientras se escribe; el guion aparece al cuarto. */
export function pintarMientrasSeEscribe(codigo) {
  const c = String(codigo ?? '');
  return c.length > 3 ? `${c.slice(0, 3)}-${c.slice(3)}` : c;
}
